export class PetitionFeesInfo {
    constructor(obj: Partial<PetitionFeesInfo>) {
        Object.assign(this, obj);
    }
    id?: number;
    sequenceNumber?: number;
    question?: string;
    questionCategory?: {
        additionalInfo?: string;
        answer?: number;
        beneficiaryId?: number;
        companyId?: number;
        employeeId?: number;
        familyId?: number;
        id?: number;
        questionId?: number;
    };
    response?: {
        id?: number;
        questionId?: number;
        answer?: any;
        additionalInfo?: string;
        beneficiaryId?: number;
        companyId?: number;
        familyId?: number;
        employeeId?: number;
    }
}